
    import { register } from "https://hfc-services-apps-stage.s3.us-west-1.amazonaws.com/web-components/latest/WebComponents.js";
    register();
  